var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-overlay',{attrs:{"absolute":""}},[_c('div',{staticClass:"accent pa-6 headline rounded",domProps:{"textContent":_vm._s(_vm.message)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }